var _path, _path2, _path3, _ellipse, _ellipse2, _path4, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoursecardProgressbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 31,
    viewBox: "0 0 314 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.541 9.96568C288.541 11.2037 288.049 12.3914 287.174 13.2668V13.2668C285.349 15.0913 285.349 18.051 287.174 19.8754V19.8754C288.049 20.7508 288.541 21.9385 288.541 23.1765V23.1765C288.541 25.7545 290.631 27.8444 293.209 27.8444V27.8444C294.447 27.8444 295.634 28.3363 296.51 29.2117V29.2117C298.333 31.0353 301.29 31.0357 303.114 29.2121V29.2121C303.99 28.3363 305.178 27.8444 306.416 27.8444V27.8444C308.996 27.8444 311.088 25.7519 311.088 23.1721V23.1721C311.088 21.9343 311.58 20.7466 312.455 19.8714V19.8714C314.277 18.0487 314.277 15.0935 312.455 13.2708V13.2708C311.58 12.3956 311.088 11.2079 311.088 9.9701V9.9701C311.088 7.39023 308.996 5.29767 306.416 5.29767V5.29767C305.178 5.29767 303.99 4.80571 303.114 3.93001V3.93001C301.29 2.10646 298.334 2.10677 296.51 3.93031V3.93031C295.635 4.80573 294.447 5.29767 293.209 5.29767V5.29767C290.631 5.29767 288.541 7.38761 288.541 9.96568V9.96568Z",
    fill: "#8E8E93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.586 9.18443C288.586 10.4225 288.094 11.6101 287.218 12.4855V12.4855C285.394 14.31 285.394 17.2697 287.218 19.0942V19.0942C288.094 19.9696 288.586 21.1572 288.586 22.3952V22.3952C288.586 24.9732 290.676 27.0631 293.254 27.0631V27.0631C294.492 27.0631 295.679 27.5551 296.555 28.4305V28.4305C298.378 30.2541 301.335 30.2544 303.159 28.4308V28.4308C304.035 27.5551 305.223 27.0631 306.461 27.0631V27.0631C309.041 27.0631 311.133 24.9706 311.133 22.3908V22.3908C311.133 21.153 311.624 19.9654 312.5 19.0901V19.0901C314.322 17.2674 314.322 14.3123 312.5 12.4896V12.4896C311.624 11.6143 311.133 10.4267 311.133 9.18885V9.18885C311.133 6.60898 309.041 4.51642 306.461 4.51642V4.51642C305.222 4.51642 304.035 4.02446 303.159 3.14876V3.14876C301.335 1.32521 298.378 1.32552 296.555 3.14906V3.14906C295.68 4.02448 294.492 4.51642 293.254 4.51642V4.51642C290.676 4.51642 288.586 6.60636 288.586 9.18443V9.18443Z",
    fill: "#0A0A0A",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.586 8.36412C288.586 9.60215 288.094 10.7898 287.218 11.6652V11.6652C285.394 13.4897 285.394 16.4494 287.218 18.2739V18.2739C288.094 19.1493 288.586 20.3369 288.586 21.5749V21.5749C288.586 24.1529 290.676 26.2428 293.254 26.2428V26.2428C294.492 26.2428 295.679 26.7347 296.555 27.6101V27.6101C298.378 29.4338 301.335 29.4341 303.159 27.6105V27.6105C304.035 26.7348 305.223 26.2428 306.461 26.2428V26.2428C309.041 26.2428 311.133 24.1503 311.133 21.5705V21.5705C311.133 20.3327 311.624 19.1451 312.5 18.2698V18.2698C314.322 16.4471 314.322 13.492 312.5 11.6693V11.6693C311.624 10.794 311.133 9.60638 311.133 8.36854V8.36854C311.133 5.78867 309.041 3.69611 306.461 3.69611V3.69611C305.222 3.69611 304.035 3.20414 303.159 2.32845V2.32845C301.335 0.504898 298.378 0.505204 296.555 2.32875V2.32875C295.68 3.20417 294.492 3.69611 293.254 3.69611V3.69611C290.676 3.69611 288.586 5.78604 288.586 8.36412V8.36412Z",
    fill: "#C7C7CC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 299.842,
    cy: 14.8808,
    rx: 10.0865,
    ry: 10.2011,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 299.843,
    cy: 14.8596,
    rx: 8.94031,
    ry: 9.05493,
    fill: "#C7C7CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M298.568 18.9923C298.872 19.408 299.662 19.4809 300 18.9753C300.929 17.5848 303.46 13.4473 304.53 11.7063C305.176 10.6568 303.657 9.96398 303.105 10.8041L301.34 13.2768C301.34 13.2768 299.727 15.5374 299.286 16.155C298.258 15.1414 297.229 14.1279 296.2 13.1144C295.521 12.4446 294.404 13.4025 294.894 14.1391L298.568 18.9923Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 7.96094,
    width: 272,
    height: 17,
    rx: 8.5,
    fill: "#C7C7CC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_795_37196)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 16,
    height: 17,
    rx: 8,
    fill: "#44A6EF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 9.19195,
    y2: -2,
    transform: "matrix(0.594427 -0.804149 0.957936 0.286983 12.4102 20.9609)",
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_795_37196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17,
    fill: "white",
    transform: "translate(0 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoursecardProgressbar);
export default __webpack_public_path__ + "static/media/Course card- Progressbar.62adf00e9e2e944112488711b1088013.svg";
export { ForwardRef as ReactComponent };